module.exports = __webpack_public_path__ + "img/commandcenter_driving.57a04e97.svg";